// v15 BOLT-065 — THE duration renderer for settings-driven windows. Any
// surface showing a curse/photo/thermo window length derives it from live (or
// explicitly-default) settings through THIS function — never a literal string.
// iOS ports it in Format.swift (parity pinned by FormatTests).
export function formatDurationMs(ms: number): string {
  return ms % 60_000 === 0 ? `${ms / 60_000} min` : `${Math.round(ms / 1000)} s`;
}
